export default __webpack_public_path__ + "static/media/tmdb_logo.e7029961.svg";